import React from "react";
import ParagraphText from "./Paragraph";
import GalleryScale from "./Gallery-Scale";
import LotusBanner from "./Banner";
import LotusDisplay from "./Display";
import LinkHeading from "./Link";
import LotusRender from "./LotusRender";
import { Wrapper, Break } from "../styles/components/Global/Global";
import { GalleryScaleWrapper } from "../styles/components/Galleries/Scale";
import {
  HeadingContainer,
  BannerWrapper,
} from "../styles/components/Global/Heading";

const SectionHeading = () => {
  return (
    <Wrapper className="scene-switch">
      <HeadingContainer />
      <HeadingContainer $absolute>
        <BannerWrapper>
          <LotusBanner />
        </BannerWrapper>
        <LotusDisplay />
      </HeadingContainer>
      <GalleryScaleWrapper>
        <GalleryScale />
      </GalleryScaleWrapper>
      <Wrapper $margin>
        <LinkHeading />
        <Break $size="small" />
        <ParagraphText
          text="For the opening of the new Lotus flagship store, they’ve built an LED techno-chromatic spectacular whose perfect stage is naturally amidst the glamor of Paris Fashion week."
          align="flex-end"
          textAlign="left"
          indent={true}
        />
      </Wrapper>
      <Wrapper>
        <LotusRender />
      </Wrapper>
    </Wrapper>
  );
};

export default SectionHeading;
